import React, { useState } from 'react';
import MarketTabs from './MarketTabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import logo from '../assets/jackpotTrnsp.png';

const Header = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <header className="sticky top-0 w-full bg-black h-[100px] px-4 flex items-center justify-between z-50 border-b border-white relative">

      {/* Hamburger Icon - show until xl (so there's never a dead zone) */}
      <div className="xl:hidden absolute right-4 top-1/2 transform -translate-y-1/2 z-20">
        <button onClick={() => setIsDrawerOpen(true)}>
          <FontAwesomeIcon icon={faBars} className="text-white h-6 w-6 mr-6" />
        </button>
      </div>

      {/* Centered logo on mobile, left on xl+ */}
      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 xl:static xl:transform-none xl:ml-8 shrink-0">
        <Link to="/" className="flex items-center shrink-0">
          <img
            src={logo}
            alt="Jackpot Logo"
            className="h-20 w-auto shrink-0 max-w-none"
          />
        </Link>
      </div>

      {/* Tabs - shown only on xl+ (matches MarketTabs desktop breakpoint) */}
      <div className="hidden xl:flex justify-center flex-grow xl:mr-20 min-w-0">
        <MarketTabs isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} />
      </div>

      {/* Spacer - desktop only */}
      <div className="hidden xl:block w-[48px]" />
    </header>
  );
};

export default Header;
